import gql from 'graphql-tag';

// This is used in Inbox page
export const SubscribeToAssociateMessageNotificationCreated = gql`
  subscription onAssociateMessageNotificationCreated($associateId: String!) {
    onAssociateMessageNotificationCreated(associateId: $associateId) {
      associateId
      contactId
      last_message
      last_date_created
      message_inbox_status
      message_type
      message_subject
      contactName
      notificationCount
    }
  }
`;

// This is used in Inbox page
export const SubscribeToAssociateMessageNotificationUpdated = gql`
  subscription onAssociateMessageNotificationUpdated($associateId: String!) {
    onAssociateMessageNotificationUpdated(associateId: $associateId) {
      associateId
      contactId
      last_message
      last_date_created
      message_inbox_status
      message_type
      message_subject
      contactName
      notificationCount
    }
  }
`;

// This is used in Inbox page
export const SubscribeToAssociateMessageNotificationRead = gql`
  subscription onAssociateMessageNotificationRead($associateId: String!) {
    onAssociateMessageNotificationRead(associateId: $associateId) {
      associateId
      contactId
      last_message
      last_date_created
      message_inbox_status
      message_type
      message_subject
      contactName
      notificationCount
    }
  }
`;

// This is used in Conversation page
export const SubscribeToMessageCreatedConversation = gql`
  subscription onMessageCreatedConversation($associateId: String!, $contactId: String!) {
    onMessageCreatedConversation(associateId: $associateId, contactId: $contactId) {
      message_status
      associateId
      contactId
      message_direction
      message_type
      message_subject
      date_created
      messageId
      message
    }
  }
`;

// This is used in Conversation page
export const SubscribeToUpdateStatusConversation = gql`
  subscription onUpdateStatusConversation($associateId: String!, $contactId: String!) {
    onUpdateStatusConversation(associateId: $associateId, contactId: $contactId) {
      message_status
      associateId
      contactId
      message_direction
      message_subject
      date_created
      messageId
      message
    }
  }
`;

// This is used in Conversation page
export const SubscribeToMessageMarkedReadConversation = gql`
  subscription onMessageMarkedReadConversation {
    onMessageMarkedReadConversation {
      associateId
      messageId
      contactId
    }
  }
`;

// This is used in GlobalNav for messages
export const SubscribeToMessageNotificationAdded = gql`
  subscription {
    onMessageNotificationAdded {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for messages
export const SubscribeToMessageNotificationCreated = gql`
  subscription {
    onMessageNotificationCreated {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for messages
export const SubscribeToMessageNotificationRead = gql`
  subscription {
    onMessageNotificationRead {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToReadNotificationCounts = gql`
  subscription onNotificationCountRead($associateId: String!) {
    onNotificationCountRead(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToCreateNotification = gql`
  subscription onNotificationCountCreated($associateId: String!) {
    onNotificationCountCreated(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToUpdatedNotificationCount = gql`
  subscription onNotificationCountUpdated($associateId: String!) {
    onNotificationCountUpdated(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in NotificationList
export const SubscribeToCreateEvents = gql`
  subscription onEventCreated($associateId: String!) {
    onEventCreated(associateId: $associateId) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
      message
      customerId
    }
  }
`;

// This is not used anywhere atm
export const SubscribeToUpdateNotification = gql`
  subscription onEventStatusUpdated($associateId: String!) {
    onEventStatusUpdated(associateId: $associateId) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
    }
  }
`;

// This is not used anywhere atm
export const SubscribeToNotification = gql`
  subscription {
    onNotificationAdded {
      id
      associateId
      notificationCounter
      messageType
    }
  }
`;
